import React from 'react';
import { SuspenseWrapper } from './SuspenseWrapper';
import { useFetchTestMedia } from '../../service/test-media/useFetchTestMedia';

function TestPageRoute() {
  const { data, isLoading } = useFetchTestMedia();

  return (
    <SuspenseWrapper isLoading={isLoading}>
      <TestPage testMedia={data ?? []} />
    </SuspenseWrapper>
  );
}

const TestPage = React.lazy(() => import('../TestView/TestPage'));

export default TestPageRoute;
